import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {resendEmailConfirmation} from '../../services/auth-service';
import MinimalLayout from "../../layouts/minimal";
import Alert from "../../components/alert";
import {ErrorMessage, Field, Form, Formik} from "formik";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {forgotPasswordRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";

export default function ResendEmailConfirmation () {
  const [responseMessage, setResponseMessage] = useState({type: 'danger', message: null});
  const [submitted, setSubmitted] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    resendEmailConfirmation({
      email: values.email
    }).then((responseData) => {
      setSubmitted(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage, "Resending of confirmation email failed.");
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
      <>
        <Section animation={HelperService.getRandomAnimation()} className="bg-image">

          <div className="container">
            <div className="row justify-content-center align-items-center h100 py-5">
              <div className="col-xxl-4 col-lg-5">

                <div className="text-center pb-5">
                  <Link to={AppRoutes.landing.path}>
                    <span><img src="/assets/images/logo.svg" alt="" height="120"/></span>
                  </Link>
                </div>

                <div className="card">

                  {submitted && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-check-circle-outline mb-2 text-success" style={{'fontSize':'50px'}}></span><br />
                      <p>We have sent you email to confirm your email address. Please follow the instructions in your email to confirm it and then <Link to={AppRoutes.login.path} className={"link-dark w-100"}>log in</Link> to start using the app.</p>
                    </div>
                  </div>}

                  {!submitted && <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Resend email confirmation</h4>
                      <p className="text-muted mb-4">Please enter email of your account</p>
                    </div>

                    <Alert type={responseMessage.type} className={"my-2"}>{responseMessage.message}</Alert>

                    <Formik
                        initialValues={forgotPasswordRequestSchema.cast()}
                        validationSchema={forgotPasswordRequestSchema}
                        onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, errors, touched }) => (
                          <Form>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">Email</label>
                              <Field required
                                     name="email"
                                     type="email"
                                     placeholder="example@sweatnow.com"
                                     className={`form-control ${errors.email && touched.email ? "is-invalid":""}`} />
                              <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </div>

                            <div className={"text-center"}>
                              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>Send</button>
                            </div>
                          </Form>
                      )}
                    </Formik>

                    <hr className={"mt-5 d-block"} />

                    <p className="text-center">
                      <Link to={AppRoutes.login.path} className={"link-dark"}>Login</Link>
                    </p>

                  </div>}

                </div>

              </div>
            </div>
          </div>

        </Section>
      </>
  );
}


ResendEmailConfirmation.getLayout = function getLayout(page) {
  return (
      <MinimalLayout>
        {page}
      </MinimalLayout>
  )
}
